import { render, staticRenderFns } from "./PatientForm.vue?vue&type=template&id=fe3716ce&"
import script from "./PatientForm.vue?vue&type=script&lang=js&"
export * from "./PatientForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports